import { OtpForm } from "@/components/formik/auth/OtpForm";
import AuthLayout from "@/components/layouts/AuthLayout";

export const OtpView = () => {
  return (
    <AuthLayout
      title="Email Verification"
      subtitle="Enter the 6-digit verification code that was sent to your email"
    >
      <OtpForm />
    </AuthLayout>
  );
};
